import React, { useEffect } from "react";

export default function Input({
  form,
  label,
  maxLength,
  minLength,
  name,
  placeholder,
  setForm = () => { },
  style,
  type = "text",
  value,
  required
}) {
  const error = form.errors !== null ? form.errors[name]?.reduce((n, m) => m, []) : null;
  useEffect(() => {
    setForm({ ...form, [name]: value })
  }, []);
  return (
    <>
      <div
        style={{
          alignContent: "center",
          display: "flex",
          flexGrow: 1,
          justifyContent: "center",
          width: "100%",
          ...style
        }}
      >
        <div style={{ display: "flex", alignItems: "center", cursor: "pointer", width: "100%" }}>
          <div
            style={{
              backgroundColor: "#fffff5",
              border: type !== "hidden" ? "1px solid rgba(0, 0, 0, .23)" : "",
              borderRadius: 4,
              color: "rgba(0, 0, 0, .6)",
              lineHeight: "20px",
              padding: ".5rem 0",
              position: "relative",
              width: "100%"
            }}
          >
            <input
              type={type}
              placeholder={placeholder}
              maxLength={maxLength}
              minLength={minLength}
              style={{
                backgroundColor: "transparent",
                border: "none",
                boxShadow: "none",
                color: "rgba(0, 0, 0, .6)",
                fontSize: 16,
                margin: 0,
                width: "100%"
              }}
              onChange={(e) => setForm({ ...form, [name]: e.target.value })}
              value={value}
              aria-label={placeholder}
              required={required}
            />
            <div
              style={{
                backgroundColor: "rgb(255, 255, 245)",
                bottom: "-.5rem",
                color: "red",
                padding: "0 .5rem",
                position: "absolute",
                right: ".5rem"
              }}
            >
              {error}
            </div>
          </div>
          <div
            style={{
              lineHeight: "14px",
              fontSize: 14,
              letterSpacing: ".25px"
            }}
          >
            {label}
          </div>
        </div>
      </div>
    </>
  );
}
